<template>
  <div class="tmc-base-simple-multi-item-select ">
    <v-select
    class="input-text-size ma-0 pa-0 mb-n4"
      :label="label"
      v-model="selectedItems"
      :items="itemList"
      multiple
      chips
    >
      <template v-slot:selection="{ item, index }">
        <v-chip v-if="index === 0">
          <span>{{ item }}</span>
        </v-chip>
        <span v-if="index === 1" class="grey--text text-caption">
          (+{{ selectedItems.length - 1 }} others)
        </span>
      </template>
      <template v-slot:prepend-item>
        <v-list-item ripple @click="toggleSelectAll">
          <v-list-item-action>
            <v-icon :color="selectedItems.length > 0 ? 'indigo darken-4' : ''">
              {{ icon }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title >Select All</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-select>
  </div>
</template>

<script>
import {
  mdiCloseBox,
  mdiCheckboxBlankOutline,
  mdiMinusBox,
} from '@mdi/js';

export default {
  name: 'SimpleMultiSelect',
  props: {
    label: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    itemList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      icons: {
        mdiCloseBox,
        mdiCheckboxBlankOutline,
        mdiMinusBox,
      },
    };
  },
  computed: {
    selectedItems: {
      get() {
        return this.items;
      },
      set(value) {
        this.$emit('selected-items', value);
      },
    },
    icon() {
      if (this.selectedItems.length === this.itemList.length) {
        return this.icons.mdiCloseBox;
      }
      if (this.selectedItems.length !== this.itemList.length && this.selectedItems.length > 0) {
        return this.icons.mdiMinusBox;
      }
      return this.icons.mdiCheckboxBlankOutline;
    },
  },
  methods: {
    toggleSelectAll() {
      this.$nextTick(() => {
        if (this.selectedItems.length === this.itemList.length) {
          this.selectedItems = [];
        } else {
          this.selectedItems = [...this.itemList];
        }
      });
    },
  },
};
</script>
